import React, { Fragment, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import _ from 'lodash';
import Header from "./header/Header";
import Body from "../../questionInspection/presentational/body/Body";
import NotEnteredAnswerPopup from "../../learning/presentational/popup/NotEnteredAnswerPopup";

const AnsweringQuestions = ( props ) => {

  const answeringCount = useRef(-1);
  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const {
    NotEnteredAnswerChecker,
    children,
    ...PROPS
  } = props;


  useEffect(() => {
    if (_.isEmpty(answeringQuestions.data)) return;

    if (answeringCount.current !== -1) {  // 첫번째 문제 시작일 때는 제외
      props.Logger(answeringQuestions.listData[answeringCount.current - 1])
    }

    // 문제 index count 저장
    answeringCount.current = answeringQuestions.answeringCount;

    return () => {
      // 마지막 문제 풀이 완료시 logger call
      if (answeringCount.current === answeringQuestions.listData.length) {
        props.Logger(answeringQuestions.listData[answeringCount.current - 1])
      }
    }
  }, [answeringQuestions.answeringCount])



  return (
    <div className="layout-def layout-learning gm">
      <Header { ...PROPS } />
      <Body { ...PROPS } />
      { answeringQuestions.isShowNotEnteredAnswerPopup && <NotEnteredAnswerChecker><NotEnteredAnswerPopup /></NotEnteredAnswerChecker> }
    </div>
  );

};

AnsweringQuestions.defaultProps = {
  NotEnteredAnswerChecker : Fragment
};

export default AnsweringQuestions;
